// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fluence as _fluence } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fluence chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 9999999
 * Chain Name: Fluence
 * Default Block Explorer: https://blockscout.mainnet.fluence.dev
 * Default RPC URL: https://rpc.mainnet.fluence.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fluence } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fluence,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fluence = createCommon({
	..._fluence,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
